import { format } from 'date-fns';

import { DatetimeMonthFormat, FormatName } from 'app/lib/datetime/types';

import { DATE_FNS_LOCALE } from 'app/constants/dateFNS';
import type { SupportedLang } from 'app/lang';
import { FALLBACK_LANG } from 'app/lang/constants';
import { DATE_FORMATS, MONTH_FORMATS } from 'app/lib/datetime/constants';

export const formatByLang = (
  value: Date,
  lang: SupportedLang,
  formatName: FormatName,
  monthFormat: DatetimeMonthFormat = DatetimeMonthFormat.FULL,
): string => {
  const month = MONTH_FORMATS[monthFormat];

  return format(value, DATE_FORMATS(month)[lang][formatName], {
    locale: DATE_FNS_LOCALE[lang],
  });
};

export const getDefaultFormat = (
  value: Date,
  isCurrentYear = false,
  monthFormat?: DatetimeMonthFormat,
): string => {
  return formatByLang(
    value,
    FALLBACK_LANG,
    isCurrentYear ? 'long' : 'longWithYear',
    monthFormat,
  );
};

export const isCurrentYear = (
  date: Date,
): boolean => {
  return date.getFullYear() === new Date().getFullYear();
};
